import { useField } from 'formik'
import PropTypes from 'prop-types'
import { Fragment } from 'react'

import FormSubtext from 'components/common/FormSubtext'
import Input from 'components/common/Input'
import Text from 'components/common/Text'
import theme from 'theme'

function TriggerField({
  title,
  description,
  fieldName,
  type,
  required,
  ...rest
}) {
  const [field, { touched, error }] = useField(fieldName)
  return (
    <Fragment>
      <div css={{ gridColumnStart: 1 }}>
        <Text as="h5" color="medium">
          {title}
          {required && <span css={{ color: 'red' }}> *</span>}
        </Text>
        <Text as="small">{description}</Text>
      </div>
      <div>
        <Input
          css={touched && error ? { borderColor: theme.colors.red[0] } : {}}
          type={type || 'text'}
          {...rest}
          {...field}
        />
        {touched && error && (
          <FormSubtext isInvalid={true}>{error}</FormSubtext>
        )}
      </div>
    </Fragment>
  )
}
TriggerField.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
  fieldName: PropTypes.string,
  required: PropTypes.bool
}
export default TriggerField
